import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoggingService } from './logging.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  constructor(
    private readonly loggingService: LoggingService,
    private readonly translateService: TranslateService
  ) { }

  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = this.translateService.instant('errorMessages.common.unknownError');
    
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    this.loggingService.error(errorMessage, error);
    return throwError(() => errorMessage);
  }

  getErrorMessage(error: HttpErrorResponse): string {
    if (error.error instanceof ErrorEvent) {
      return error.error.message;
    } else {
      // Check for various error message formats
      // RFC 7807 Problem Details format uses 'title' field
      // Standard API responses may use 'message' field
      const errorMessage = error.error?.message ?? 
                           error.error?.title ?? 
                           error.message ?? 
                           this.translateService.instant('errorMessages.common.unknownError');
      
      // Translate specific error messages (case-insensitive check)
      if (errorMessage && typeof errorMessage === 'string') {
        const lowerErrorMessage = errorMessage.toLowerCase();
        if (lowerErrorMessage.includes('old and new password should not match') || 
            lowerErrorMessage.includes('old and new password must not match')) {
          return this.translateService.instant('errorMessages.auth.oldAndNewPasswordMatch');
        }
      }
      
      return errorMessage;
    }
  }
}

